export const modal = {
  confirm: 'Confirm action',
  confirm_content: 'Are you sure you want to delete the entry # {id}?',
  edit: 'Edit post',
  create: 'Add a post',
  export: 'Export statistics',
  create_recording: 'Create archive of records',
  warning: 'Warning',
  add_ip: 'Add IP',

  field: {
    search: {
      placeholder: 'Search'
    }
  },

  confirmation: {
    recording: 'Are you sure you want to export your recordings?'
  }
};
